import { DefectSettingsData } from '../defects/defect-settings.data';

export namespace DefectDefaults {
  /**
   * Creates default defect settings object.
   * @return {DefectSettingsData}
   */
  export function SETTINGS(): DefectSettingsData {
    return {
      id: '',
      estateId: '',
      defectType: [],
      buildingRequired: false,
      stairwayRequired: false,
      floorRequired: false,
      apartmentDefectEnabled: false
    };
  }
}
